export default {
  function: require('./function'),
  number: require('./number'),
  string: require('./string'),
  object: require('./object'),
  array: require('./array')
}